import type { YMap }  from '@yandex/ymaps3-types';
import * as React     from 'react';
import { IMapMarker } from '../../map.types';

import MapMarker from '../marker';

import type { MapLayoutProps } from './map.layout.props';

const MapLayout: React.FC<MapLayoutProps> = function(props) {
  const {
          Yandex,
          center,
          children,
          location,
          onUpdate,
          zoom,
        } = props;

  const mapRef = React.useRef<YMap | null>(null);

  React.useEffect(() => {
    mapRef.current?.setLocation({
      center,
      easing:   'ease',
      duration: 3e2,
      zoom,
    });
  }, [center, zoom]);

  return (
    <Yandex.YMap
      behaviors={[
        'dblClick',
        'drag',
        'magnifier',
        'oneFingerZoom',
        'pinchZoom',
      ]}
      location={Yandex.reactify.useDefault({
        center,
        easing:   'ease',
        duration: 3e2,
        zoom,
      })}
      mode={'vector'}
      ref={mapRef}
    >
      <Yandex.YMapDefaultSchemeLayer />
      <Yandex.YMapDefaultFeaturesLayer />
      <Yandex.YMapListener onUpdate={onUpdate} />
      <Yandex.YMapControls
        orientation={'vertical'}
        position={'top left'}
      >
        <Yandex.YMapZoomControl
          duration={3e2}
          easing={'ease'}
        />
      </Yandex.YMapControls>
      {location && (
        <Yandex.YMapMarker coordinates={Yandex.reactify.useDefault([location.lng, location.lat])}>
          <MapMarker
            active
            {...location}
          />
        </Yandex.YMapMarker>
      )}
      {children}
    </Yandex.YMap>
  );
};

export default MapLayout;